import { put, takeEvery } from 'redux-saga/effects';
import { reset } from 'redux-form';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from './actions';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as constants from './appConstants';
import { pushFlashMessage } from 'common/actions';
import { FLASH_SUCCESS } from 'common/components/FlashMessages';

export function* unsubscribeAddress() {
  yield put(reset(constants.ADDRESS_FORM_NAME));
  yield put(pushFlashMessage(constants.ADDRESS_FORM_SUCCESS, FLASH_SUCCESS));
}

export default function* saga() {
  yield takeEvery(actions.UNSUBSCRIBE_ADDRESS_REQUEST, unsubscribeAddress);
}
